import React from 'react';

// Types
import { ReviewState } from 'Shared/types/Review.type';

// Utils
import { unixDateMMMDDYYYY } from 'Shared/utils/DateTime.utils';

// Helpers
import * as ReviewsHelpers from 'Shared/model_helpers/Reviews.helper';

// Selectors

type Props = {
  review;
  isPeerReviewForm?: boolean;
};

const ReviewDueDate = ({ review, isPeerReviewForm = false }: Props) => {
  const state = ReviewsHelpers.getState(review);
  const dueBy = ReviewsHelpers.getDuBy(review);
  const peerReviewDueBy = ReviewsHelpers.getPeerReviewDueBy(review);

  const date =
    isPeerReviewForm || state === ReviewState.PEER_REVIEW
      ? `${unixDateMMMDDYYYY(peerReviewDueBy)}`
      : `${unixDateMMMDDYYYY(dueBy)}`;

  if (![ReviewState.PEER_REVIEW, ReviewState.COMPILATION].includes(state)) {
    return null;
  }

  return <span className="ReviewDueDate">Due {date}</span>;
};

export default ReviewDueDate;
